import { Loading } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { useFetchCurrentBloomMenu } from '@jane/business-admin/data-access';

export const RequirePremiumAccess = ({ children }: PropsWithChildren) => {
  const { data, isPending, isFetched } = useFetchCurrentBloomMenu();

  if (isPending || !isFetched) {
    return <Loading />;
  }

  if (!data?.menu_url) {
    return <Navigate to="/" />;
  }
  return <>{children}</>;
};
